module.exports = __webpack_public_path__ + "img/founders_12.68b3791c.jpg";